const isNumber = (event) => {
    if (!event) return false;

    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        event.preventDefault();
    } else {
        return true;
    }
};

const maxLength = (e, limit) => {
    return String(e).substring(0, limit);
};

const chunkArray = (array) => {
    let tempArray = [];
    for (let i = 0; i < array.length; i++) {
        tempArray.push(array.slice(i, i + 1));
    }
    return tempArray;
};

const monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month, index) => {
    let _index = index + 1;
    let value = _index > 9 ? `${_index}` : `0${_index}`;
    return {
        value: value,
        text: month
    };
});

const yearsArray = (start, end) => {
    return Array(Number(end) - Number(start) + 1).fill(Number(start)).map((year, index) => year + index);
};

const daysArray = (count) => {
    return Array(Number(count)).fill(1).map((day, index) => day + index);
};

const arrayDiff = (a1, a2) => {
    let a = [], diff = [];
    for (let i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
    }
    for (let i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
            delete a[a2[i]];
        } else {
            a[a2[i]] = true;
        }
    }
    for (let k in a) {
        diff.push(k);
    }
    return diff;
};

const getStatusColor = (status) => {
    switch (status) {
        case "new":
            return "primary";
        case "draft":
            return "secondary";
        case "in_process":
            return "warning";
        case "process-error":
            return "danger";
        case "completed":
        case "complete":
            return "success";
    }
};

const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

const getZoomByRadius = (radius) => {
    if (radius <= 5) {
        return 12;
    } else if (radius > 5 && radius <= 10) {
        return 10;
    } else if (radius > 10 && radius <= 25) {
        return 10;
    } else if (radius > 25 && radius <= 50) {
        return 8;
    } else if (radius > 50 && radius <= 200) {
        return 6;
    }
};

export default {
    isNumber,
    maxLength,
    chunkArray,
    monthArray,
    yearsArray,
    daysArray,
    arrayDiff,
    getStatusColor,
    formatBytes,
    getZoomByRadius
};
